var _radialGradient, _radialGradient2, _radialGradient3, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _path10, _use, _use2, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgV8Turbofan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#fff",
    viewBox: "0 0 4700 4700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 2426,
    cy: 2072,
    r: 1679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 2338,
    cy: 2102,
    r: 370,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20",
    stopOpacity: 0.04
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 28,
    cy: 604,
    r: 4682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#424242"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1870 1324v2986h959V1324zm935 2961h-909V1349h909z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 578l431 746h1440v2986h960V1324h1436l431-746z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4682 604l15-26H-1l16 26z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M823 1324H430l123 213h177c27-74 57-145 93-213zm3040 0c35 68 66 140 92 213h188l123-213z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M633 2107c0-944.8 765.3-1710 1710-1710s1710 765.3 1710 1710-765.3 1710-1710 1710S633 3051.7 633 2107z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M740 1511H538l15 26h177c4-9 7-18 10-26zm3206 0l9 26h188l15-26zM2343 3792c-940 0-1703-759-1710-1698v12c0 944 766 1710 1710 1710s1710-766 1710-1710v-12c-7 939-770 1698-1710 1698z",
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2343 422c940 0 1703 759 1710 1698v-12c0-944-766-1710-1710-1710S633 1164 633 2108v12c7-939 770-1698 1710-1698z",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M1223 2126c0-618.8 501.2-1120 1120-1120s1120 501.2 1120 1120-501.2 1120-1120 1120-1120-501.2-1120-1120z",
    opacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M4042 2302l-741-741-123 71-482-482-341 890-165 708 149 498 499 499c643-195 1126-757 1204-1443z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e8e8",
    d: "M2339 1025v1110l492-657c-27-281-225-453-492-453zm-971 550l971 560-323-753c-257-117-514-38-648 193zm9 1116l962-556-813-96c-231 164-283 421-149 652z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#d6d6d6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2339 3246V2136l-490 637c26 281 222 473 490 473zm323-358c257 118 515 20 648-211l-970-568z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3301 1580l-962 556 813 96c230-165 283-422 149-652z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2339 2116V1006c267 0 463 173 490 455zm0 0l-962-556c135-231 383-315 639-197zm0 0l-962 556c-134-231-81-488 149-652z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e8e8",
    d: "M2339 2116v1110c-267 0-463-173-490-455zm0 0l962 556c-134 231-382 315-639 197zm0 0l962-556c134 231 81 488-149 652z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#e"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M3108 578c-230-115-490-181-765-181s-535 65-765 181H-1l7 13 8 14 539 933h177c-63 178-98 370-98 570 0 780 523 1439 1237 1644v558h959v-563c707-210 1223-864 1223-1640 0-200-34-392-98-570h188l554-959zM798 1374c-1 1-1 2-2 4 0-1 1-2 2-4zm-24 53c0 1-1 2-1 3 0-2 0-2 1-3zm3114-53c1 1 1 2 2 4 0-1-1-2-2-4zm24 53c0 1 1 2 1 3 0-2 0-2-1-3z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M1968 2102a370 370 0 11370 370 369.9 369.9 0 01-370-370z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgV8Turbofan);
export default __webpack_public_path__ + "static/media/v8-turbofan.5ea6821220dea4d8ca709061a21816c8.svg";
export { ForwardRef as ReactComponent };